module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Clarity-Established.7e0bfc06.jpeg";